var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHazardidentification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(-708 -279)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(708 279)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a00fe2f22bc672f6d8758a2f006cea36",
    transform: "translate(714.004 283.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M28.977,35.955h-.13l.016-1.7h.114c.5,0,1-.024,1.491-.071l.164,1.689c-.547.053-1.1.08-1.655.08Zm-1.909-.106a16.985,16.985,0,0,1-1.762-.292l.366-1.658a15.211,15.211,0,0,0,1.586.262Zm5.331-.239-.34-1.663a15.316,15.316,0,0,0,1.555-.4l.514,1.618a16.767,16.767,0,0,1-1.731.45Zm-8.816-.529a17.147,17.147,0,0,1-1.662-.656l.706-1.545a14.973,14.973,0,0,0,1.495.594ZM35.8,34.529l-.679-1.554a15.322,15.322,0,0,0,1.435-.723l.843,1.474a17.281,17.281,0,0,1-1.6.8ZM20.338,33.6a16.887,16.887,0,0,1-1.488-.99l1.019-1.358a15.363,15.363,0,0,0,1.333.888Zm18.556-.837L37.9,31.38a15.239,15.239,0,0,0,1.252-1.006l1.132,1.265a16.875,16.875,0,0,1-1.393,1.12ZM17.476,31.467a17.2,17.2,0,0,1-1.249-1.273L17.5,29.072a15.426,15.426,0,0,0,1.124,1.149Zm24.078-1.083L40.3,29.243A15.571,15.571,0,0,0,41.315,28l1.369,1a17.281,17.281,0,0,1-1.13,1.384ZM15.12,28.79a17.214,17.214,0,0,1-.956-1.508l1.48-.832a15.469,15.469,0,0,0,.86,1.358Zm28.543-1.284-1.47-.855a14.63,14.63,0,0,0,.733-1.43l1.551.694A17.108,17.108,0,0,1,43.663,27.506Zm-30.29-1.823a16.892,16.892,0,0,1-.617-1.675l1.621-.5a15.173,15.173,0,0,0,.556,1.508Zm31.748-1.431-1.613-.525a15.311,15.311,0,0,0,.417-1.553l1.661.353a17.482,17.482,0,0,1-.464,1.722Zm-32.8-1.979a16.932,16.932,0,0,1-.255-1.769l1.691-.149a15.219,15.219,0,0,0,.227,1.59ZM45.862,20.76l-1.69-.177a15.582,15.582,0,0,0,.085-1.606h1.7A17.31,17.31,0,0,1,45.862,20.76ZM13.7,18.747,12,18.723a17.231,17.231,0,0,1,.12-1.783l1.686.2a15.18,15.18,0,0,0-.108,1.6Zm30.517-.918a15.347,15.347,0,0,0-.2-1.592l1.67-.3a16.5,16.5,0,0,1,.225,1.772ZM14.08,15.56l-1.655-.379a17.092,17.092,0,0,1,.489-1.718l1.607.551a15.306,15.306,0,0,0-.441,1.546Zm29.563-.889a15.045,15.045,0,0,0-.532-1.514l1.57-.648a16.493,16.493,0,0,1,.594,1.687Zm-28.52-2.145-1.539-.719a17.147,17.147,0,0,1,.84-1.576l1.454.875a15.518,15.518,0,0,0-.756,1.419Zm27.3-.817a14.94,14.94,0,0,0-.84-1.37l1.4-.964a17.233,17.233,0,0,1,.934,1.523ZM16.778,9.773,15.42,8.749a17.025,17.025,0,0,1,1.15-1.366l1.24,1.159a15.637,15.637,0,0,0-1.032,1.231Zm23.829-.712a15.655,15.655,0,0,0-1.1-1.167l1.169-1.231a17.055,17.055,0,0,1,1.229,1.3ZM18.972,7.433,17.857,6.146a17.133,17.133,0,0,1,1.407-1.1l.976,1.391a15.3,15.3,0,0,0-1.269.993Zm19.3-.579a15.4,15.4,0,0,0-1.326-.915L37.835,4.5a16.977,16.977,0,0,1,1.472,1.011ZM21.6,5.59,20.783,4.1a16.771,16.771,0,0,1,1.608-.779l.658,1.561a15.279,15.279,0,0,0-1.445.7Zm13.931-.418a15.319,15.319,0,0,0-1.486-.613l.564-1.6a16.937,16.937,0,0,1,1.651.679ZM24.563,4.345,24.071,2.72A17,17,0,0,1,25.806,2.3l.316,1.669A14.89,14.89,0,0,0,24.563,4.345Zm7.948-.238a15.39,15.39,0,0,0-1.581-.286l.214-1.685a17.237,17.237,0,0,1,1.756.318Zm-4.8-.359-.139-1.692q.7-.052,1.4-.057h.385l-.045,1.7h-.34c-.424.024-.849.017-1.262.051Z",
    transform: "translate(-1.512)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 16.129,
    cy: 16.129,
    r: 16.129,
    transform: "translate(11.337 2.849)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M30.338,9,21,27.675H39.675Z",
    transform: "translate(-2.872 -1.058)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M9,54H19.186v6.791H9Z",
    transform: "translate(-1.059 -7.859)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M17.279,48.129a8.609,8.609,0,0,0-3.263-6.791l-1.263-2.632a1.328,1.328,0,0,0-1.188-.764A1.371,1.371,0,0,0,10.259,39.6l.495,2.587,1.631,3.4A14.422,14.422,0,0,1,5.593,35.435l-.32-2A1.669,1.669,0,0,0,3.648,32a1.693,1.693,0,0,0-1.636,1.928l.467,3.889A20.5,20.5,0,0,0,9.122,50.675h8.157Z",
    transform: "translate(0 -4.534)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M53.186,60.791H43V54H53.186Z",
    transform: "translate(-6.197 -7.859)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M44,48.129a8.609,8.609,0,0,1,3.263-6.791l1.263-2.632a1.328,1.328,0,0,1,1.188-.764A1.371,1.371,0,0,1,51.02,39.6l-.495,2.587-1.631,3.4a14.422,14.422,0,0,0,6.791-10.147l.32-2A1.669,1.669,0,0,1,57.631,32a1.693,1.693,0,0,1,1.636,1.928L58.8,37.816a20.5,20.5,0,0,1-6.643,12.859H44Z",
    transform: "translate(-6.348 -4.534)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 1.698,
    height: 5.093,
    rx: 0.849,
    transform: "translate(26.617 15.582)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 1.698,
    height: 1.698,
    rx: 0.849,
    transform: "translate(26.617 22.373)",
    fill: "#fef8e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazardidentification);
export default __webpack_public_path__ + "static/media/hazardidentification.24f8ed78ea0316b78d385d76bbf5f2bb.svg";
export { ForwardRef as ReactComponent };